$.lui("comp",".comp_booking",function (selector) {
    let bookolo = selector.find("#bookolo-engine");

    if(bookolo.length) {
        let bookolo_script = document.createElement('script');
        bookolo_script.src = "https://www.bookoloengine.com/v3/bookolo.js?v=3";
        bookolo.after(bookolo_script);
    }
});